import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { LogIn, UserPlus } from "lucide-react";

export const InlineAuth = ({ onAuthed }) => {
  const { login, register } = useAuth();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async () => {
    if (mode === "register" && !form.name.trim()) { toast.error("Isi nama lengkap"); return; }
    if (!/\d{8,}/.test(form.phone.replace(/\D/g, ""))) { toast.error("Isi nomor WhatsApp yang valid"); return; }
    if (form.password.length < 6) { toast.error("Kata sandi minimal 6 karakter"); return; }
    setLoading(true);
    try {
      const u = mode === "login"
        ? await login(form.phone, form.password)
        : await register({ name: form.name, phone: form.phone, password: form.password, role: "passenger" });
      toast.success(mode === "login" ? "Berhasil masuk" : "Akun member berhasil dibuat");
      onAuthed?.(u);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="grid gap-3" data-testid="inline-auth">
      <div className="grid grid-cols-2 gap-2">
        {[{ v: "login", l: "Masuk", icon: LogIn }, { v: "register", l: "Daftar Member", icon: UserPlus }].map((o) => (
          <button
            key={o.v} type="button" data-testid={`inline-auth-tab-${o.v}`}
            onClick={() => setMode(o.v)}
            className={`flex items-center justify-center gap-2 border px-3 py-2.5 text-sm font-semibold transition-colors ${mode === o.v ? "border-primary bg-primary/10 text-primary" : "border-border text-muted-foreground hover:border-primary/50"}`}
          >
            <o.icon className="h-4 w-4" /> {o.l}
          </button>
        ))}
      </div>

      {mode === "register" && (
        <div className="grid gap-1.5">
          <Label>Nama Lengkap</Label>
          <Input data-testid="inline-auth-name" value={form.name} onChange={set("name")} placeholder="Nama sesuai identitas" />
        </div>
      )}
      <div className="grid gap-1.5">
        <Label>Nomor WhatsApp</Label>
        <Input data-testid="inline-auth-phone" inputMode="tel" value={form.phone} onChange={set("phone")} placeholder="08xxxxxxxxxx" />
      </div>
      <div className="grid gap-1.5">
        <Label>Kata Sandi</Label>
        <Input data-testid="inline-auth-password" type="password" value={form.password} onChange={set("password")} placeholder="Minimal 6 karakter" onKeyDown={(e) => { if (e.key === "Enter") submit(); }} />
      </div>

      <Button data-testid="inline-auth-submit" onClick={submit} disabled={loading} className="w-full bg-primary py-5 font-bold text-primary-foreground hover:bg-primary/90">
        {loading ? "Memproses..." : mode === "login" ? "Masuk & Lanjutkan" : "Daftar & Lanjutkan"}
      </Button>
      <p className="text-center text-[11px] text-muted-foreground">
        {mode === "login"
          ? <>Belum punya akun? <button type="button" data-testid="inline-auth-switch-register" onClick={() => setMode("register")} className="text-primary hover:underline">Daftar member gratis</button></>
          : <>Sudah punya akun? <button type="button" data-testid="inline-auth-switch-login" onClick={() => setMode("login")} className="text-primary hover:underline">Masuk di sini</button></>}
      </p>
    </div>
  );
};
